import _directionRightLine from "@zenlayer/zen-design-icons/assets/direction/RightLine.svg";
import _directionLeftLine from "@zenlayer/zen-design-icons/assets/direction/LeftLine.svg";
import { useDebounceFn, useSize } from 'ahooks';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { pickDomAttrs } from '../_util/utils';
import Icon from '../icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ScrollLegend = _ref => {
  var _containerSize$width, _contentSize$width;
  let {
    selectedLegend,
    legend,
    onChange,
    prefixClass,
    className,
    style,
    ...restProps
  } = _ref;
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const containerSize = useSize(containerRef);
  const contentSize = useSize(contentRef);
  const [leftDisabled, setLeftDisabled] = useState(true);
  const [rightDisabled, setRightDisabled] = useState(false);
  const showArrow = ((_containerSize$width = containerSize === null || containerSize === void 0 ? void 0 : containerSize.width) !== null && _containerSize$width !== void 0 ? _containerSize$width : 0) < ((_contentSize$width = contentSize === null || contentSize === void 0 ? void 0 : contentSize.width) !== null && _contentSize$width !== void 0 ? _contentSize$width : 0);
  const setButtonDisabled = () => {
    if (containerRef.current) {
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = containerRef.current;
      setLeftDisabled(scrollLeft <= 0);
      setRightDisabled(scrollLeft >= scrollWidth - clientWidth);
    }
  };
  const {
    run: checkScroll
  } = useDebounceFn(setButtonDisabled, {
    wait: 100
  });
  const handleScroll = to => {
    if (!containerRef.current || !containerSize) {
      return;
    }
    containerRef.current.scrollBy({
      left: to === 'left' ? -containerSize.width : containerSize.width,
      behavior: 'smooth'
    });
  };
  useEffect(checkScroll, [containerSize === null || containerSize === void 0 ? void 0 : containerSize.width]);
  const attrs = pickDomAttrs(restProps);
  return /*#__PURE__*/_jsxs("div", {
    ...attrs.data,
    className: classNames("".concat(prefixClass, "--scroll_legend"), className),
    style: style,
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        width: 20
      },
      children: showArrow && /*#__PURE__*/_jsx("a", {
        className: classNames('arrow-btn', {
          disabled: leftDisabled
        }),
        onClick: () => {
          !leftDisabled && handleScroll('left');
        },
        children: /*#__PURE__*/_jsx(Icon, {
          type: "direction/LeftLine",
          block: true
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      ref: containerRef,
      onScroll: checkScroll,
      className: "scroll-container",
      children: /*#__PURE__*/_jsx("div", {
        ref: contentRef,
        className: "scroll-inner",
        children: legend === null || legend === void 0 ? void 0 : legend.map(item => {
          var _item$stroke;
          if (!item) {
            return null;
          }
          const isMarkLine = item.type === 'markLine';
          const stroke = (_item$stroke = item.stroke) !== null && _item$stroke !== void 0 ? _item$stroke : isMarkLine ? 'dashed' : 'solid';
          return /*#__PURE__*/_jsxs("div", {
            className: "legend-item",
            style: {
              cursor: isMarkLine ? 'default' : 'pointer'
            },
            onClick: () => {
              !isMarkLine && (onChange === null || onChange === void 0 ? void 0 : onChange(item.key));
            },
            children: [/*#__PURE__*/_jsxs("div", {
              className: "line",
              style: {
                opacity: selectedLegend !== null && selectedLegend !== void 0 && selectedLegend[item.key] || isMarkLine ? '1' : '0.5',
                color: item.color,
                columnGap: stroke === 'dashed' ? 2 : 0
              },
              children: [/*#__PURE__*/_jsx("i", {}), /*#__PURE__*/_jsx("i", {}), /*#__PURE__*/_jsx("i", {}), stroke === 'solid' && /*#__PURE__*/_jsx("i", {})]
            }), /*#__PURE__*/_jsx("div", {
              className: "label",
              children: item.name
            })]
          }, item.key);
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      style: {
        width: 20
      },
      children: showArrow && /*#__PURE__*/_jsx("a", {
        className: classNames('arrow-btn', {
          disabled: rightDisabled
        }),
        onClick: () => {
          !rightDisabled && handleScroll('right');
        },
        children: /*#__PURE__*/_jsx(Icon, {
          type: "direction/RightLine",
          block: true
        })
      })
    })]
  });
};